import React, { useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import New_1 from '../../../assets/images/home_page_3/new-arrival/01.png';
import New_2 from '../../../assets/images/home_page_3/new-arrival/02.png';
import New_3 from '../../../assets/images/home_page_3/new-arrival/03.png';
import New_4 from '../../../assets/images/home_page_3/new-arrival/04.png';

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
};

const products = {
    Men: [
        { id: 1, image: New_1, name: 'The Nordic Guys-0495', price: '$420' },
        { id: 2, image: New_2, name: 'The Fedredic Hudi-0398', price: '$420' },
        { id: 3, image: New_3, name: 'Smart t shirt-0089', price: '$420' },
        { id: 4, image: New_4, name: 'Smart shirt-0098', price: '$420' },
    ],
    Women: [
        { id: 5, image: New_1, name: 'The Nordic Guys-0495', price: '$420' },
        { id: 6, image: New_2, name: 'The Fedredic Hudi-0398', price: '$420' },
        { id: 7, image: New_3, name: 'Smart t shirt-0089', price: '$420' },
        { id: 8, image: New_4, name: 'Smart shirt-0098', price: '$420' },
    ]
};

const NewArrival = () => {
    const [category, setCategory] = useState("Men");

    const handleTabChange = (tab) => {
        setCategory(tab);
    };

    return (
        <section id="new-arrival" className="new-arrival-main-block">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section text-center">
                            <div className="section-sub-title">Weekly Sales</div>
                            <h4 className="section-title-three">New Arrival In this week</h4>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <ul className="new-arrival-nav nav nav-pills" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <Link
                                    className={`nav-link ${category === "Men" ? "active" : ""}`}
                                    onClick={() => handleTabChange("Men")}
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-men"
                                    title=""
                                    role="tab"
                                    aria-controls="pills-men"
                                    aria-selected={category === "Men"}
                                >
                                    Men's
                                </Link>
                            </li>
                            <li className="nav-item" role="presentation">
                                <Link
                                    className={`nav-link ${category === "Women" ? "active" : ""}`}
                                    onClick={() => handleTabChange("Women")}
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-women"
                                    title=""
                                    role="tab"
                                    aria-controls="pills-women"
                                    aria-selected={category === "Women"}
                                >
                                    Women's
                                </Link>
                            </li>
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div className={`tab-pane fade ${category === 'Men' ? 'show active' : ''}`} id="pills-men" role="tabpanel">
                                <Slider className="slider new-arrival-autoplay" {...settings}>
                                    {products.Men.map(product => (
                                        <div key={product.id} className="new-arrival-product-block">
                                            <div className="new-arrival-product-img">
                                                <Link to="/ShopDetails" title="">
                                                    <img src={product.image} className="img-fluid" alt={product.name} />
                                                </Link>
                                                <div className="overlay-bg" />
                                                <div className="new-arrival-product-icons">
                                                    <ul>
                                                        <li>
                                                            <Link to="" title="">
                                                                <i className="flaticon-search" />
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="" title="">
                                                                <i className="flaticon-bag" />
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="" title="">
                                                                <i className="flaticon-reload" />
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="new-arrival-product-btn-icon">
                                                    <Link to="#" title="" className="btn btn-primary-three">
                                                        Add To Cart
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="new-arrival-product-dtl">
                                                <h6 className="new-arrival-product-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        {product.name}
                                                    </Link>
                                                </h6>
                                                <p className="new-arrival-product-price">{product.price}</p>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>

                            <div className={`tab-pane fade ${category === 'Women' ? 'show active' : ''}`} id="pills-women" role="tabpanel">
                                <Slider className="slider new-arrival-autoplay" {...settings}>
                                    {products.Women.map(product => (
                                        <div key={product.id} className="new-arrival-product-block">
                                            <div className="new-arrival-product-img">
                                                <Link to="/ShopDetails" title="">
                                                    <img src={product.image} className="img-fluid" alt={product.name} />
                                                </Link>
                                                <div className="overlay-bg" />
                                                <div className="new-arrival-product-icons">
                                                    <ul>
                                                        <li>
                                                            <Link to="" title="">
                                                                <i className="flaticon-search" />
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="" title="">
                                                                <i className="flaticon-bag" />
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="" title="">
                                                                <i className="flaticon-reload" />
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="new-arrival-product-btn-icon">
                                                    <Link to="#" title="" className="btn btn-primary-three">
                                                        Add To Cart
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="new-arrival-product-dtl">
                                                <h6 className="new-arrival-product-name jakarta-font">
                                                    <Link to="/ShopDetails" title="">
                                                        {product.name}
                                                    </Link>
                                                </h6>
                                                <p className="new-arrival-product-price">{product.price}</p>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default NewArrival;